import { THREAD_MARK_ATTR } from './inject-thread-marks';

export const scrollToThreadMark = (threadId: string): void => {
  document
    .querySelector(`mark[${THREAD_MARK_ATTR}~="${threadId}"]`)
    ?.scrollIntoView({ block: 'center', behavior: 'smooth' });
};
